// PhaseHeader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import IconButton from '../../../common/icon_button/icon_button.jsx'

class PhaseHeader extends Component {
  static get propTypes () {
    return {
      columnOptions: PropTypes.array,
      onColumnOptions: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      columnOptions: [],
      onColumnOptions: null
    }
  }

  _renderCustomColumns () {
    const columnsTitle = {
      budget: 'project.budgetContent.labelBudget',
      sales: 'project.budgetContent.labelSales',
      spent: 'project.budgetContent.labelSpent'
    }

    const columnsEnabled = []
    if (this.props.columnOptions) {
      this.props.columnOptions.forEach(column => {
        if (!column.disabled && column.selected) {
          columnsEnabled.push(column.ident)
        }
      })
    }

    const noColumns = columnsEnabled.length
    return columnsEnabled.map((column, idx) => {
      return (
        <div className={`col ${noColumns}col ${column}`} key={idx}>
          <IntlMessage ident={columnsTitle[column]} />
        </div>
      )
    })
  }

  render () {
    return (
      <div className='phase-header'>
        <div className='col select'>
          <IntlMessage ident='project.budgetContent.labelSelect' />
        </div>
        <div className='col title'>
          <IntlMessage ident='project.budgetContent.labelTitle' />
        </div>
        <div className='col hours'>
          <IntlMessage ident='project.budgetContent.labelHours' />
        </div>
        <div className='col price'>
          <IntlMessage ident='project.budgetContent.labelPrice' />
        </div>
        {this._renderCustomColumns()}
        <div className='col actions'>
          <IconButton
            icon='settings'
            type='normal'
            size='small'
            className='actionsetting'
            canHover
            onClick={this.props.onColumnOptions}
          />
        </div>
      </div>
    )
  }
}

export default PhaseHeader
